import { useCallback } from 'react';

import Button from '../../../../shared/components/Button/Button';
import { amplitudeService } from '../../../../shared/amplitude';
import { SelectPurchase } from '../../../../shared/amplitude/events/product/SelectPurchase';
import { getFusionQueryId } from '../../shared/utils/productDetailEvent';
import { useAppSelector } from '../../../../shared/store';
import useProductBuy from '../../hooks/useProductBuy';
import type { ContentType } from '../../types';

interface EventSelectPurchaseProps {
  no: number;
  name: string;
  contentType: ContentType;
  isGroupProduct: boolean;
  deliveryTypeNames: string[];
  sellerName: string;
  retailPrice: number | null;
  basePrice: number;
  discountedPrice: number | null;
  isSoldOut: boolean;
  defaultContentId: number;
  queryId: string | null;
}
const eventSelectPurchase = ({
  no,
  name,
  contentType,
  isGroupProduct,
  deliveryTypeNames,
  sellerName,
  retailPrice,
  basePrice,
  discountedPrice,
  isSoldOut,
  defaultContentId,
  queryId,
}: EventSelectPurchaseProps) => {
  amplitudeService.logEvent(
    new SelectPurchase({
      productDetailState: {
        no,
        name,
        contentType,
        isGroupProduct,
        deliveryTypeNames,
        sellerName,
        retailPrice,
        basePrice,
        discountedPrice,
        isSoldOut,
      },
      defaultContentId,
      fusionQueryId: getFusionQueryId(queryId),
    }),
  );
};

export default function CartButtonContainer() {
  const queryId = useAppSelector(({ productList }) => productList.queryId);
  const {
    no,
    name,
    contentType,
    isGroupProduct,
    deliveryTypeNames,
    sellerName,
    retailPrice,
    basePrice,
    discountedPrice,
    defaultContentId,
    isDirectOrder,
    isSoldOut,
    isPurchaseStatus,
  } = useAppSelector(({ productDetail }) => productDetail);

  const isButtonDisable = isSoldOut || !isPurchaseStatus;

  const { buyText, buyProduct } = useProductBuy({
    isDirectOrder,
    isSoldOut,
    isPurchaseStatus,
  });

  const handleClickCartButton = useCallback(async () => {
    eventSelectPurchase({
      no,
      name,
      contentType,
      isGroupProduct,
      deliveryTypeNames,
      sellerName,
      retailPrice,
      basePrice,
      discountedPrice,
      isSoldOut,
      defaultContentId,
      queryId,
    });
    await buyProduct();
  }, [
    basePrice,
    buyProduct,
    contentType,
    defaultContentId,
    deliveryTypeNames,
    discountedPrice,
    isGroupProduct,
    isSoldOut,
    name,
    no,
    queryId,
    retailPrice,
    sellerName,
  ]);

  return (
    <Button
      text={buyText}
      className="cart-button"
      radius={3}
      onClick={handleClickCartButton}
      disabled={isButtonDisable}
    />
  );
}
